<template>
  <div drop-select :class="{ open }" @click="toggle">
    <label class="item">{{ selected && selected.label }}</label>
    <div drop-select-wrapper :style="{ height: dropHeight }">
      <ul>
        <li class="item" v-for="item in list" :key="item.value" @click="change(item)" :selected="item.value === value">{{ item.label }}</li>
        <li class="item" v-for="(label, key) in obj" :key="key" @click="change({label, value: key})" :selected="value === key">{{ label }}</li>
      </ul>
    </div>
  </div>
</template>

<style lang="less">
 @import "../../less/vars";
 @import "../../less/asset";

  [drop-select] { cursor: pointer; .rel; z-index: 1; .-box; .h(46);
    label { .block; .rel; cursor: pointer;
      &:after { .cnt; .wh(9px, 6px); .abs; .rt(15px, 50%); margin-top: -3px; background: url("@{common}/arrow-down-g.png"); }
    }
    [drop-select-wrapper] { .-box; overflow: hidden; height:0; transition: 0.3s; .rel;
      ul { .abs; .lb; width:100%; }
    }
    &.open {
      box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2); z-index: 100; height: auto;
    }
  }
</style>
<!--suppress JSUnresolvedFunction -->
<script>
import _ from 'lodash';
import { isTouch } from '../../utils';

export default {
  name: 'DropSelect',
  props: {
    value: { default: null },
    list: { type: Array, default: null },
    obj: { type: Object, default: null },
  },
  data() {
    return {
      open: false,
      selected: null,
      dropHeight: 0,
    };
  },
  mounted() {
    this.update();
  },
  watch: {
    value() {
      this.update();
    },
  },
  computed: {
    down() {
      return isTouch() ? 'touchstart' : 'mousedown';
    },
  },
  methods: {
    closeCheck(event) {
      let { target } = event;
      while (target) {
        if (target === this.$el) return;
        target = target.parentNode;
      }
      this.close();
    },
    openSelect() {
      this.open = true;
      this.dropHeight = `${this.$el.querySelector('ul').offsetHeight}px`;
      window.addEventListener(this.down, this.closeCheck);
    },
    close() {
      this.open = false;
      this.dropHeight = 0;
      window.removeEventListener(this.down, this.closeCheck);
    },
    toggle() {
      if (!this.open) {
        this.openSelect();
      } else {
        this.close();
      }
    },
    change(val) {
      this.selected = val;
      this.$emit('input', val.value);
    },
    update() {
      if (this.$props.list) {
        if (this.$props.value !== undefined) {
          this.selected = _.find(this.$props.list, { value: this.$props.value });
        } else {
          [this.selected] = this.$props.list;
        }
      }
      if (this.$props.obj) {
        if (this.$props.value !== undefined) {
          this.selected = { label: this.$props.obj[this.$props.value], value: this.$props.value };
        } else {
          _.forEach(this.$props.obj, (label, value) => {
            if (!this.selected) this.selected = { label, value };
          });
        }
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/components/DropSelect.vue